import { useMemberPaymentApi } from "@apis/useMemberPaymentApi";
import { isEmpty, isFunction } from "@util/utils";
import useValidationErrors from "@util/hook/useValidationErrors";
import useShowPDF from "@util/hook/useShowPDF";

const buildPostParams = ({ sourceData, formData, pluginPath }) => {
	return {
		memberPaymentID: sourceData?.memberPaymentID || 0,
		memberID: sourceData?.memberID,
		sourceType: sourceData?.sourceType,
		creditCardBankName: formData?.creditCardBankName,
		creditCardType: formData?.creditCardType,
		creditCardNo: formData?.creditCardNo,
		cardExpiryDate: formData?.cardExpiryDate,
		cardName: formData?.cardName,
		cardRelation: formData?.cardRelation || "",
		employeeID: formData?.employeeID,
		notes: "",
		cardSignImg: formData?.cardSignImg,
		signImg: formData?.signImg,
		plugIns: {
			path: pluginPath || "",
			note: formData?.note || "",
			token: pluginPath,
		},
	};
};

const useCreditCardSubmitHandler = ({ formAdapter, isPaperAuthorization, sourceData, uploadAuthorizationFile, refresh }) => {
	const showPDF = useShowPDF();
	const { postMemberPaymentCreditCardApi } = useMemberPaymentApi();
	const { validationErrors, updateValidationErrors, clearValidationErrors } = useValidationErrors();

	const checkError = () => {
		clearValidationErrors();
		if (isPaperAuthorization && isEmpty(formAdapter.getFile())) {
			formAdapter.showError("請上傳信用卡授權書");
			return true;
		}

		return formAdapter.validateForm();
	};

	const postMemberPaymentApi = async params => {
		const { memberID, ...other } = params || {};
		const resp = await postMemberPaymentCreditCardApi(memberID, other);

		if (resp?.isError) {
			// 0002 錯誤
			updateValidationErrors(resp.result);
		} else if (isEmpty(resp)) {
			// 失敗
		} else {
			// 成功
			showPDF({
				open: true,
				pdfUrl: resp?.completedPath,
			});
			isFunction(refresh) && refresh();
		}
	};

	const onSubmitApi = async () => {
		if (checkError()) return;

		const formData = formAdapter.getFormData();

		let pluginPath = "";
		if (isPaperAuthorization) {
			pluginPath = await uploadAuthorizationFile({
				memberID: sourceData.memberID,
				paymentID: sourceData.memberPaymentID,
			});

			if (!pluginPath) {
				formAdapter.showError("授權書上傳失敗，請重新嘗試");
				return;
			}
		}
		const params = buildPostParams({
			sourceData,
			formData,
			pluginPath,
		});
		await postMemberPaymentApi(params);
	};

	return {
		checkError,
		onSubmit: onSubmitApi,
		validationErrors,
	};
};

export default useCreditCardSubmitHandler;
